export const FETCH_MERCHANT_ROLE_ACCESS_REQUEST = 'FETCH_MERCHANT_ROLE_ACCESS_REQUEST';
export const FETCH_MERCHANT_ROLE_ACCESS_SUCCESS = 'FETCH_MERCHANT_ROLE_ACCESS_SUCCESS';
export const FETCH_MERCHANT_ROLE_ACCESS_FAILURE = 'FETCH_MERCHANT_ROLE_ACCESS_FAILURE';
